function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "40",
  height: "36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.5 8.5A1.5 1.5 0 0117 10v4a1.5 1.5 0 01-3 0v-4a1.5 1.5 0 011.5-1.5zM17 22a1.5 1.5 0 00-3 0v4a1.5 1.5 0 003 0v-4z",
  fill: "#E9688A"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 8A7.5 7.5 0 017.5.5h25A7.5 7.5 0 0140 8v3.647c0 1.023-.83 1.853-1.853 1.853A4.147 4.147 0 0034 17.647v.706a4.147 4.147 0 004.147 4.147c1.023 0 1.853.83 1.853 1.853V28a7.5 7.5 0 01-7.5 7.5h-25A7.5 7.5 0 010 28v-3.647C0 23.33.83 22.5 1.853 22.5A4.147 4.147 0 006 18.353v-.706A4.147 4.147 0 001.853 13.5 1.853 1.853 0 010 11.647V8zm7.5-4.5A4.5 4.5 0 003 8v2.592c3.402.548 6 3.498 6 7.055v.706a7.149 7.149 0 01-6 7.055V28a4.5 4.5 0 004.5 4.5h25A4.5 4.5 0 0037 28v-2.592a7.149 7.149 0 01-6-7.055v-.706a7.149 7.149 0 016-7.055V8a4.5 4.5 0 00-4.5-4.5h-25z",
  fill: "#E9688A"
})));